/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { ActionType, EventName } from "@microsoftit/telemetry-extensions-npm";

import { ErrorSeverity } from "../../components/constants";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { appInsights } from "./telemetry";
import { config } from "../config";
import { getURLParams } from "../../components/util";
import { logHeartFeatureEvent } from "./telemetryHeartWrapper";

const commonLogProperties = {
  environmentName: config.telemetry.environmentName,
  serviceOffering: config.telemetry.serviceOffering,
  serviceLine: config.telemetry.serviceLine,
  service: config.telemetry.service,
  componentName: config.telemetry.componentName,
  subComponentName: config.telemetry.subComponentName,
  componentId: config.telemetry.componentId,
  candidateId: getURLParams().candidateId,
  correlationId: config.telemetry.sessionId,
  language: "",
};

//Logging to Heart Metrics --> Business Events
export const logTelemetry = (
  featureName: string,
  subfeatureName: string,
  actionType: ActionType,
  actionName: string,
  eventName: EventName,
  properties?: any
): void => {

  //This is done so that once the application gets candidate id, it gives the correct id
  commonLogProperties.candidateId = getURLParams().candidateId;
  const logProperties = {
    ...commonLogProperties, ...properties
  };

  logHeartFeatureEvent(
    featureName,
    subfeatureName,
    actionType,
    actionName,
    eventName,
    logProperties
  );
};

//Logging to App Insights --> Engineering Events
export const logToAppInsights = (
  featureName: string,
  properties?: any
): void => {
  //This is done so that once the application gets candidate id, it gives the correct id
  commonLogProperties.candidateId = getURLParams().candidateId;
  const logProperties = commonLogProperties;
  if (properties) {
    Object.assign(logProperties, properties);
  }
  appInsights.trackEvent({
    name: featureName,
    properties: logProperties,
  });
};

//Logging Exceptions to App Insights
export const logException = (
  exception: Error,
  severityLevel?: SeverityLevel,
  errorSeverity?: ErrorSeverity,
  correlationId?: string
) => {
  const errorLogProperties = {
    serviceOffering: config.telemetry.serviceOffering,
    serviceLine: config.telemetry.serviceLine,
    service: config.telemetry.service,
    componentName: config.telemetry.componentName,
    subComponentName: config.telemetry.subComponentName,
    componentId: config.telemetry.componentId,
    errorSeverity: errorSeverity?.toString() ?? ErrorSeverity.Low.toString(),
    correlationId: correlationId ?? config.telemetry.sessionId,
    errorMessage: exception?.message,
    EnvironmentName: config.telemetry.environmentName,
  };
  appInsights.trackException(
    {
      exception: exception,
      severityLevel: severityLevel ?? SeverityLevel.Error,
    },
    errorLogProperties
  );
};